import React, { useState } from "react";
import fetchData from "../../api/fetchApi"
export default function ApiResponseViewer() {
  const [endpoint, setEndpoint] = useState("");
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleFetch = async () => {
    setLoading(true);
    setError(null);
    setResponse(null);
    try {
      const data = await fetchData(endpoint);
      setResponse(data);
    } catch (err) {
      setError(err.message || "حدث خطأ أثناء جلب البيانات");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6 bg-white rounded shadow">
      <h2 className="text-xl font-bold mb-4">عرض استجابة API</h2>
      <div className="mb-4 flex gap-2">
        <input
          type="text"
          className="border rounded px-3 py-2 w-full"
          placeholder="أدخل endpoint مثل: finance/accounts"
          value={endpoint}
          onChange={e => setEndpoint(e.target.value)}
        />
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded"
          onClick={handleFetch}
          disabled={loading || !endpoint}
        >
          جلب البيانات
        </button>
      </div>
      {loading && <div className="text-gray-500">جاري التحميل...</div>}
      {error && <div className="text-red-600 mb-2">{error}</div>}
      {response && (
        <pre className="bg-gray-100 p-4 rounded overflow-x-auto text-sm">
          {JSON.stringify(response, null, 2)}
        </pre>
      )}
    </div>
  );
}
